import React from 'react';
import { Phone, Menu } from 'lucide-react';
export function Header() {
  return <header className="sticky top-0 z-50 w-full border-b border-border/40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60" data-id="element-49">
      <div className="container flex h-20 max-w-screen-2xl items-center justify-between" data-id="element-50">
        <div className="flex items-center gap-2" data-id="element-51">
          <img src="https://cdn.magicpatterns.com/uploads/n9D75188rNsFCRtFuBjbv5/hauser-logo.webp" alt="Hauser's Complete Care" className="h-12 object-contain" data-id="element-52" />
        </div>
        <nav className="hidden md:flex items-center gap-8 text-sm font-medium" data-id="element-53">
          <a href="#services" className="transition-colors hover:text-primary" data-id="element-54">
            Services
          </a>
          <a href="#reviews" className="transition-colors hover:text-primary" data-id="element-55">
            Reviews
          </a>
          <a href="#quote" className="transition-colors hover:text-primary" data-id="element-56">
            Free Quote
          </a>
        </nav>
        <div className="flex items-center gap-4" data-id="element-57">
          <a href="tel:+15555555555" className="hidden md:flex items-center gap-2 text-sm font-medium text-primary hover:text-primary/80" data-id="element-58">
            <Phone className="h-4 w-4" data-id="element-59" />
            <span data-id="element-60">Call Now</span>
          </a>
          <a href="#quote" className="inline-flex h-10 items-center justify-center rounded-md bg-primary px-6 text-sm font-medium text-primary-foreground shadow transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50" data-id="element-61">
            Get a Quote
          </a>
        </div>
      </div>
    </header>;
}